export default {
  metaTitle: '管理大促活动商品',
  pageTitle: '管理大促活动商品',
  submitTime: '提交时间',
  placeholder1: '活动名称',
  placeholder2: '活动CODE',
  placeholder3: 'Listing#',
  placeholder4: '商品名',
  bigpromotionstatus1: '待审核',
  bigpromotionstatus2: '待开始',
  bigpromotionstatus3: '进行中',
  bigpromotionstatus4: '已过期',
  bigpromotionstatus5: '取消或下架或拒绝',
  passed: '已通过',
  reject: '已拒绝',
  expiredReview: '未审核已过期',
  columns1: 'Listing ID',
  columns2: '店铺ID',
  columns3: '标题',
  columns4: '价格区间',
  columns5: '提交时间',
  columns6: '促销活动ID',
  columns7: '活动名',
  columns8: '创建时间',
  columns9: '活动CODE',
  columns10: '活动状态',
  columns11: '生效时间',
  columns12: '操作',
  content1: '确定执行取消操作吗',
  success1: '成功',
  checkState: '审核状态'
}
